import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=30366fd0&scoped=true"
import script from "./DeliveryInfo.vue?vue&type=script&lang=ts"
export * from "./DeliveryInfo.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=30366fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30366fd0",
  null
  
)

export default component.exports